import type { ReactNode } from "react";

interface OptionProps {
  name: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  onSelect: () => void;
  children: ReactNode;
}

/**
 * Ladrilho escolhível do design. O input nativo fica visualmente escondido mas
 * continua sendo o alvo do teclado e do leitor de tela; o visual reage por
 * `peer-checked`, por isso o conteúdo precisa ser irmão do input.
 */
export function OptionTile({ name, value, checked, disabled, onSelect, children }: OptionProps) {
  return (
    <label className={disabled ? "cursor-not-allowed" : "cursor-pointer"}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onSelect}
        className="peer sr-only"
      />
      <span className="block h-full rounded-md border-[1.5px] border-border bg-background p-3.5 transition-colors hover:bg-foreground/[0.03] peer-checked:border-primary peer-checked:bg-orange-50 peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-2 peer-disabled:opacity-60">
        {children}
      </span>
    </label>
  );
}

/** Mesma ideia do ladrilho, no formato pílula que o design usa para o motivo. */
export function OptionChip({ name, value, checked, onSelect, children }: OptionProps) {
  return (
    <label className="cursor-pointer">
      <input type="radio" name={name} value={value} checked={checked} onChange={onSelect} className="peer sr-only" />
      <span className="block rounded-full border-[1.5px] border-border bg-background px-4 py-2 text-[0.8125rem] font-semibold text-color-medium transition-colors hover:bg-foreground/[0.03] peer-checked:border-primary peer-checked:bg-primary peer-checked:text-primary-foreground peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-2">
        {children}
      </span>
    </label>
  );
}
